class BannerCountdown extends HTMLElement {
    constructor() {
        super();
        this.bannerCountDownItems = this.querySelectorAll('.banner_countdown');
        this.setup();
    }

    setup() {
        this.bannerCountDownItems.forEach((val, index, array) => {
            this.enableCountdown(val);
        });
    }

    enableCountdown(bannerDiv) {
        const dateTo = bannerDiv.getAttribute('data-countdown-date-to');
        const timezone = bannerDiv.getAttribute('data-timezone');
        const bckColor = bannerDiv.getAttribute('data-background-color');
        const currentDate = DateUtils.getCurrentDate(timezone);

        if (dateTo == "" || dateTo < currentDate) {
            return true;
        }

        const countDownDate = new Date(dateTo).getTime();

        const t = setInterval(function () {
            const countdownValues = DateUtils.getCountdown(countDownDate, timezone);

            if (countdownValues.length == 0) {
                clearInterval(t);
                bannerDiv.innerHTML = '';
                bannerDiv.style.backgroundColor = "transparent";
            }

            bannerDiv.innerHTML = countdownValues.join(' : ');
            bannerDiv.style.backgroundColor = bckColor;

        }.bind(DateUtils.getCountdown), 1000);
    }
}
customElements.define('banner-countdown', BannerCountdown);